import {BasePageRequest} from './BasePageRequest';

export class AbsenceSearchRequest extends BasePageRequest {
    fullName: string;
    absenceTypeId: number;
    departmentId: number;
    status:number;
    absenceStartDate: string;
    absenceEndDate: string;

    constructor(pageNumber: any, size: any, sortColumn: any, sortDirection: any) {
        super(pageNumber, size, sortColumn, sortDirection);
    }
}
